import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import React from 'react'

export interface HiddenOnBreakpointProps {
    breakpoint?: number | 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

/**
 * This HOC hides the given children when the
 * screen size goes below the specified breakpoint.
 *
 * @param breakpoint target breakpoint, defaults to "xs"
 */
const HiddenOnBreakpoint: React.FC<HiddenOnBreakpointProps> = ({
    children,
    breakpoint = 'xs',
}) => {
    const theme = useTheme()
    const xsDown = useMediaQuery(theme.breakpoints.down(breakpoint))

    return !xsDown ? <>{children}</> : null
}

export default HiddenOnBreakpoint
